// Disclosure navigation with top-level links (WAI-ARIA APG pattern).
// The link navigates; the adjacent button opens the panel for keyboard and
// assistive-technology users. Mouse hover is handled in CSS and is unchanged.
(() => {
  const toggles = document.querySelectorAll('.mega-menu__toggle');
  if (!toggles.length) return;

  const setOpen = (toggle, open) => toggle.setAttribute('aria-expanded', String(open));
  const closeAll = (except) => toggles.forEach((toggle) => toggle !== except && setOpen(toggle, false));

  toggles.forEach((toggle) => {
    const item = toggle.closest('li');

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      closeAll(toggle);
      setOpen(toggle, !open);
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;
      setOpen(toggle, false);
      toggle.focus();
      event.stopPropagation();
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(toggle, false);
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.header__inline-menu li')) closeAll();
  });
})();
